module.exports = __webpack_public_path__ + "img/shop-front.b154eea9.jpeg";